import VConsole from "vconsole";

let vConsole: VConsole | null = null;

/**
 * Initialize vconsole for mobile debugging in development mode only
 * Shows a floating button that opens a console panel overlay
 */
export const initDebugConsole = (): void => {
  // Only initialize in development mode
  if (process.env.NODE_ENV !== "development" || window.innerWidth > 768) {
    return;
  }

  // Prevent multiple initializations
  if (vConsole) {
    return;
  }

  try {
    vConsole = new VConsole({
      theme: "dark", // Use dark theme for better mobile readability
      defaultPlugins: ["system", "network", "element", "storage"], // Include useful debugging panels
      maxLogNumber: 1000, // Keep up to 1000 log entries
    });

    console.log("🐛 VConsole initialized for mobile debugging");
  } catch (error) {
    console.error("Failed to initialize VConsole:", error);
  }
};

/**
 * Destroy vconsole instance
 */
export const destroyDebugConsole = (): void => {
  if (vConsole) {
    vConsole.destroy();
    vConsole = null;
    console.log("🐛 VConsole destroyed");
  }
};

/**
 * Toggle vconsole visibility
 */
export const toggleDebugConsole = (): void => {
  if (vConsole) {
    if (vConsole.isInited) {
      vConsole.hideSwitch();
    } else {
      vConsole.showSwitch();
    }
  }
};

/**
 * Check if vconsole is available (development mode only)
 */
export const isDebugConsoleAvailable = (): boolean => {
  return process.env.NODE_ENV === "development";
};
